<template>
    <div class="wrap-row-content">
      <span class="w6" :style="{ color: colorLabel }">{{ labelPlan }}</span>
      <span class="amount-fee" :style="{ color: colorValue }">{{ valuePlan }}</span>
    </div>
    <hr class="hr-item"/>
</template>
<script>
export default {
  props: {
    labelPlan: {
      type: [String, Number],
    },
    colorLabel: {
      type: [String, Number],
    },
    valuePlan: {
      type: [String, Number],
      default: () => {
      },
    },
    colorValue: {
      type: [String, Number],
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit('handleCloseModal');
    },
    async handleChangePlan() {
      this.$root.$refs.loading.start();
      const body = {
        plan_id: this.plan.id,
      };
      await this.$store.dispatch('monthly-plan/actChangeMonthlyPlan', body);
      this.$root.$refs.loading.finish();
      this.handleCloseModal();
      this.$emit('handleGetDataPlan');
    },
  },
};
</script>
